import axios from 'axios';
import numeral from '../utils/numeral';

export function createDirectDebit(fields) {
    return axios.post(
        '/api/direct_debits',
        Object.assign({}, fields, {
            amount: numeral(fields.amount)
                .value()
                .toFixed(2)
        })
    );
}
